/* Mobile menu panels (snippets/drawer-menu.liquid): a category opens its own panel over the top level,
   "Menu" goes back. The theme's drawer (timber.LeftDrawer in theme.js) still opens and closes it; this
   adds a dimmed backdrop that closes it, and starts it at the top level each time it opens. */
(function() {
  var nav = document.querySelector('[data-pl-nav]');
  if (!nav) return;
  var root = document.getElementById('PlNavRoot');
  var current = null;
  var opener = null;

  nav.querySelectorAll('[data-pl-nav-panel]').forEach(function(panel) {
    panel.hidden = false;
    panel.setAttribute('tabindex', '-1');
    if (panel !== root) panel.setAttribute('aria-hidden', 'true');
  });

  // Keyboard users get focus on "Menu" (with its ring); a tap focuses the panel quietly instead
  function show(panel, trigger, byKeyboard) {
    if (!panel) return;
    root.classList.add('is-behind');
    root.setAttribute('aria-hidden', 'true');
    panel.scrollTop = 0;
    panel.classList.add('is-active');
    panel.removeAttribute('aria-hidden');
    current = panel;
    opener = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    var back = panel.querySelector('[data-pl-nav-back]');
    var target = byKeyboard && back ? back : panel;
    setTimeout(function() { target.focus({ preventScroll: true }); }, 60);
  }

  function back(restoreFocus, byKeyboard) {
    if (!current) return;
    current.classList.remove('is-active');
    current.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-behind');
    root.removeAttribute('aria-hidden');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (restoreFocus) (byKeyboard ? opener : root).focus({ preventScroll: true });
    }
    current = null;
    opener = null;
  }

  nav.addEventListener('click', function(evt) {
    var open = evt.target.closest('[data-pl-nav-open]');
    if (open) {
      show(document.getElementById(open.getAttribute('data-pl-nav-open')), open, evt.detail === 0);
      return;
    }
    if (evt.target.closest('[data-pl-nav-back]')) back(true, evt.detail === 0);
  });

  // Dimmed backdrop: clicking it closes the menu
  var scrim = document.createElement('div');
  scrim.className = 'pl-nav-scrim';
  scrim.setAttribute('aria-hidden', 'true');
  document.body.appendChild(scrim);
  scrim.addEventListener('click', function(evt) {
    if (window.timber && timber.LeftDrawer && timber.LeftDrawer.drawerIsOpen) timber.LeftDrawer.close(evt);
  });

  // Each time the menu closes, return to the top level (after the slide-out)
  new MutationObserver(function() {
    if (!document.body.classList.contains('js-drawer-open-left') && current) {
      setTimeout(function() {
        if (!document.body.classList.contains('js-drawer-open-left')) back(false);
      }, 360);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();

/* Sticky header (see pl-nav.css): keep the header's normal height as its space in the page, so nothing jumps
   when jquery.sticky fixes it at the top, and collapse it to its stuck size in step with the scroll (--pl-shrink,
   0 to 1 over the height it loses). jquery.sticky starts on window load; the header is measured then and on resize. */
(function() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var range = 0;

  function stickyWrapper() {
    var wrapper = header.parentElement;
    return wrapper && wrapper.classList.contains('sticky-wrapper') ? wrapper : null;
  }

  function update() {
    var wrapper = stickyWrapper();
    if (!wrapper) return;
    var past = window.pageYOffset - (wrapper.getBoundingClientRect().top + window.pageYOffset);
    var shrink = range > 0 ? Math.min(1, Math.max(0, past / range)) : 1;
    header.style.setProperty('--pl-shrink', shrink.toFixed(3));
  }

  // Render the header unstuck and then stuck and fully collapsed for an instant (transitions off) to get both heights.
  function measure() {
    var wrapper = stickyWrapper();
    if (!wrapper) return;
    var stuck = wrapper.classList.contains('is-sticky');
    var shrink = header.style.getPropertyValue('--pl-shrink');
    wrapper.classList.add('pl-header-measure');
    wrapper.classList.remove('is-sticky');
    var natural = header.offsetHeight;
    wrapper.classList.add('is-sticky');
    header.style.setProperty('--pl-shrink', '1');
    var compact = header.offsetHeight;
    if (!stuck) wrapper.classList.remove('is-sticky');
    if (shrink) header.style.setProperty('--pl-shrink', shrink);
    void header.offsetHeight;
    wrapper.classList.remove('pl-header-measure');

    if (natural > 0) wrapper.style.setProperty('--pl-header-space', natural + 'px');
    range = Math.max(0, natural - compact);
    update();
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('load', function() { setTimeout(measure, 60); });
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(measure, 150);
  });
})();
